import { analyticsReport } from "@dataseat-dsp-client/lib-reporter";

export type IOrderedColumn = analyticsReport.IOrderedColumn;
export type TReportColumnType = analyticsReport.TReportColumnType;
export type IHiddenColumns = analyticsReport.IHiddenColumns;

export const CUSTOM_COLUMN_POSITION = analyticsReport.CUSTOM_COLUMN_POSITION;
export const CUSTOM_COLUMN_ORDER = analyticsReport.CUSTOM_COLUMN_ORDER;
